import { render, staticRenderFns } from "./Up.vue?vue&type=template&id=21bb38e9&scoped=true"
import script from "./Up.vue?vue&type=script&lang=js"
export * from "./Up.vue?vue&type=script&lang=js"
import style0 from "./Up.vue?vue&type=style&index=0&id=21bb38e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bb38e9",
  null
  
)

export default component.exports